<div class="row justify-content-center align-items-center h-100">
  <div class="col-lg-9">
    <div
      class="d-flex align-items-center justify-content-center w-100 h-100 flex-column gap-9 text-center"
    >
      <img
        src="/assets/images/backgrounds/side-img.svg"
        alt="login-side-img"
        width="300"
        class="img-fluid"
      />
      <h4 class="mb-0 f-s-22 m-y-20">
        Conexão e Gestão de serviços que funcionam
      </h4>
      <p class="f-s-15 m-b-20 m-t-0 mat-body-1">
        Sua rede de Manutenção e Facilities B2B
      </p>
    </div>
  </div>
</div>
